module.exports = __webpack_public_path__ + "b9e17a850383dbc146287b7c101e2f2d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-11.png
// module id = 3135
// module chunks = 0